module.exports = __webpack_public_path__ + "img/front4.e773ac7f.jpg";